import Select from 'react-select';
import styled from 'styled-components';

const BillFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    props.$isActive
      ? 'padding-bottom: 1rem; border-bottom: 1px solid #cccccc;'
      : ''}

  @media (max-width: 768px) {
    display: ${(props) => (props.$isMobile ? 'flex' : 'none')};
  }
`;

const BillSelect = styled.div`
  width: 100%;
`;

const BillFilterLabel = styled.label`
  display: ${(props) => (props.$isActive ? 'block' : 'none')};
  font-size: 0.75rem;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #cccccc',
    borderRadius: '0.25rem',
    boxShadow: 'none',
    minHeight: '2rem',
    fontSize: '0.875rem',
    '&:hover': {
      border: '1px solid #cccccc',
    },
  }),
  // Hide the indicator separator (pipe)
  indicatorSeparator: () => ({
    display: 'none',
  }),
  // Style the placeholder text
  placeholder: (base) => ({
    ...base,
    color: '#212121',
  }),
  // Style the dropdown arrow (optional but helpful for consistent styling)
  dropdownIndicator: (base) => ({
    ...base,
    color: '#212121',
    padding: '0 0.5rem 0 0',
    '&:hover': {
      color: '#000000',
    },
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};

export const ArchiveBillFilter = ({
  setSelectedBills,
  selectedBills,
  bills,
  isMobile = false,
  isActive = false,
}) => {
  // Handler for bill selection
  const handleBillSelect = (selectedOption) => {
    if (!selectedOption) {
      setSelectedBills([]);
      return;
    }
    if (!selectedBills.includes(selectedOption.value)) {
      setSelectedBills([...selectedBills, selectedOption.value]);
    }
  };

  return (
    <>
      <BillFilterContainer $isMobile={isMobile} $isActive={isActive}>
        <BillFilterLabel $isActive={isActive} htmlFor="archive-bill-select">
          Bill ID
        </BillFilterLabel>
        <BillSelect $isMobile={isMobile}>
          <Select
            inputId="archive-bill-select"
            options={bills}
            placeholder="Bill ID"
            onChange={handleBillSelect}
            value={null}
            isClearable={true}
            styles={selectStyles}
          />
        </BillSelect>
      </BillFilterContainer>
    </>
  );
};
